<template>
  <div
    class="alert font-weight-bold"
    role="alert"
    :class="getClasses(color, dismissible)"
  >
    <div class="d-flex flex-row gap-2">
      <div class="d-flex flex-column gap-2">
        <span v-if="icon" class="alert-icon">
          <i :class="getIcon(icon)" />
        </span>
        <span v-if="title" class="alert-title">
          {{ title }}
        </span>
      </div>
    </div>
    <span class="alert-text fw-normal mt-4 mp-4">
      <slot />
    </span>
    <button
      v-if="dismissible"
      type="button"
      class="btn-close d-flex justify-content-center align-items-center color-black"
      data-bs-dismiss="alert"
      aria-label="Close"
      @click="actionClose"
    >
      <font-awesome-icon icon="fa-solid fa-times" />
    </button>
  </div>
</template>

<style scoped>
  .alert {
    z-index: auto!important;
  }
  .alert-primary {
    background: #F4F9FF;
    color: #000;
  }
  .btn-close {
    color: #000;
  }
</style>

<script>
export default {
  name: "argon-alert",
  props: {
    title: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      default: "success",
    },
    icon: String,
    dismissible: {
      type: Boolean,
      default: false,
    },
    actionClose: {
      type: Function,
      default: null,
    },
  },
  methods: {
    getClasses: (color, dismissible) => {
      let classes = {};
      classes["alert-" + color] = color
      classes["alert-dismissible fade show"] = dismissible

      return classes;
    },
    getIcon: (icon) => (icon ? icon : null),
  },
};
</script>
